module.exports = __webpack_public_path__ + "img/Group 27486.cd924b19.png";